import React from 'react';
import foto2 from '../../assets/foto_2_grid.png';
import foto3 from '../../assets/foto_3_grid.png';
import foto4 from '../../assets/foto_4_grid.png';
import './PhotosSection.css';

const INSTAGRAM_URL = 'https://www.instagram.com/hakacompany/';

const PhotosSection = () => {
  const photos = [foto2, foto3, foto4];

  return (
    <section className="photos-section">
      <h2 className="photos-title">FOTOS</h2>
      <div className="photos-grid">
        {photos.map((photo, index) => (
          <a
            key={index}
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="photo-item"
            aria-label={`Ver foto ${index + 1} no Instagram`}
          >
            <img src={photo} alt={`Foto ${index + 1}`} className="photo-image" loading="lazy" />
          </a>
        ))}
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="photos-cta"
          aria-label="Acesse nosso Instagram"
        >
          <span className="cta-text">Acesse Nosso Instagram</span>
          <span className="cta-arrow">→</span>
        </a>
      </div>
    </section>
  );
};

export default PhotosSection;
